import {
    registerSelectEditControl
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-select-edit-control.component";
import {Component, Injector} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {EmployeeSearchModel} from "../employee-search.model";
import {EmployeeSearchPageComponent} from "../employee-search-page/employee-search-page.component";
import {EmployeeEditPageComponent} from "../employee-edit-page/employee-edit-page.component";
import {
    AbstractSingleSelectEditControlComponent
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-single-select-edit-control.component";

@Component({
    selector: "wbo-employee-single-select-edit-control",
    templateUrl: "../../../framework/entity/edit/edit-controls/select-edit-controls/single-select-edit-control.component.html",
    providers: [
        registerSelectEditControl(EmployeeSingleSelectEditControlComponent),
        provideSearchModel(EmployeeSearchModel)
    ]
})
export class EmployeeSingleSelectEditControlComponent extends AbstractSingleSelectEditControlComponent<EmployeeSearchModel> {
    constructor(model: EmployeeSearchModel, injector: Injector) {
        super(model, injector, "employeeId", "fullName");

        this.extendedSearchComponent = EmployeeSearchPageComponent;
        this.extendedEditComponent = EmployeeEditPageComponent;
    }
}
